// extracted by mini-css-extract-plugin
export default {"primary-nav-width":"56px","breadcrumb-height":"56px","routeContainer":"styles_routeContainer__Vy3vy","container":"styles_container__PW54A"};